import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course03 from "../../../course/course-03/course";
import lesson0318 from "../lesson-18/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "4fc7c8a9-cc3a-4250-b1d4-eb49c9bd4e59",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0318),
    lesson: lesson0318,
  },
];

export default lessonLinks;
